import { GoalThreshold } from '../../coaching-base/config';
import {
    CommitmentApprovalDto,
    CommitmentKpi,
} from '../../coaching-base/general';
import { createAction } from '../../store.model';
import { FocusKPI } from '../models/commitment.model';

export enum ActionType {
    COACHING_COMMITMENT__GOAL_LIST__RELOAD = 'COACHING_COMMITMENT__GOAL_LIST__RELOAD',
    COACHING_COMMITMENT__GOAL_LIST__SORT = 'COACHING_COMMITMENT__GOAL_LIST__SORT',
    COACHING_COMMITMENT__GOAL_LIST__SET_CATEGORY_OPEN_STATE = 'COACHING_COMMITMENT__GOAL_LIST__SET_CATEGORY_OPEN_STATE',
}

export interface Reload {
    commitmentKpis: CommitmentKpi[];
    goalsFromOtherCommitments: CommitmentKpi[];
    focusKpis: FocusKPI[];
    goalThresholds: GoalThreshold[];
    approval: CommitmentApprovalDto;
    authUserId: number;
    reset: boolean;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING_COMMITMENT__GOAL_LIST__RELOAD,
);

/// /////// separator //////////

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Sort {}

export const sort = createAction<ActionType, Sort>(
    ActionType.COACHING_COMMITMENT__GOAL_LIST__SORT,
);

/// /////// separator //////////

export interface SetCategoryOpenState {
    index: number;
    isOpen: boolean;
}

export const setCategoryOpenState = createAction<
    ActionType,
    SetCategoryOpenState
>(ActionType.COACHING_COMMITMENT__GOAL_LIST__SET_CATEGORY_OPEN_STATE);
